import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const PollPage = lazyWithRetry(() => import("@/features/poll/pages/PollPage").then((m) => ({ default: m.PollPage })));

export const POLL_PATH = "/sondage";

const pollRoutes: RouteConfig[] = [
  {
    path: POLL_PATH,
    element: <PollPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default pollRoutes;
